<prox-main [parent]="this" [bodyTemplate]="bodyTemplate"></prox-main>
<ng-template #bodyTemplate>
  <div class="flex flex-col h-full mt-10">
    <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[40, 60]">
      <!-- Top panel: Product Type Tags grid -->
      <ng-template pTemplate>
        <div class="flex-col pt-2 pb-2 w-full h-full">
          <prox-ag-grid [gridOptions]="pptGridOptions"></prox-ag-grid>
        </div>
      </ng-template>
      <!-- Bottom panel: Two grids side-by-side with horizontal splitter -->
      <ng-template pTemplate>
        <p-splitter class="w-full h-full" layout="horizontal" styleClass="h-full" [panelSizes]="[67, 33]">
          <!-- Left panel: Product Configuration dropdown + grid -->
          <ng-template pTemplate>
            <div class="flex flex-col w-full h-full">
              <div class="flex ml-2 mt-2 mb-2">
                <p-floatlabel class="w-56" variant="in">
                  <p-select [disabled]="!selectedPpt" [(ngModel)]="selectedPtc" (ngModelChange)="onSelectedPtcChange()"
                    inputId="ptcs" [options]="ptcs" optionLabel="name" class="w-full" variant="filled" />
                  <label for="ptcs">Product Configuration</label>
                </p-floatlabel>
              </div>
              <div class="flex flex-1 pt-2 pb-2 h-full w-full">
                <prox-ag-grid class="w-full" [gridOptions]="ptcpGridOptions" [rowData]="ptcps">
                </prox-ag-grid>
              </div>
            </div>
          </ng-template>
          <!-- Right panel: Add-ons grid -->
          <ng-template pTemplate>
            <div class="flex w-full h-full pt-2 pb-2 pl-2">
              <prox-ag-grid class="w-full" [gridOptions]="ptcaGridOptions" [rowData]="ptcas">
              </prox-ag-grid>
            </div>
          </ng-template>
        </p-splitter>
      </ng-template>
    </p-splitter>
  </div>
</ng-template>